import { render } from "./CDBOffense.vue?vue&type=template&id=b3ef499a&scoped=true"
import script from "./CDBOffense.vue?vue&type=script&lang=js"
export * from "./CDBOffense.vue?vue&type=script&lang=js"

import "./CDBOffense.vue?vue&type=style&index=0&id=b3ef499a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ef499a"]])

export default __exports__